/* src/app/question/question.component.scss */
.content-container {
  position: relative;
  max-width: 1180px;
  max-height: 90vh;
  margin: 0 auto 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 577px;
}
.content-container h2 {
  padding: 0px;
  max-width: 816px;
  margin: 0 auto;
  font-family: "Campton-SemiBold";
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 1px;
  color: #ffffff;
}
.content-container .buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
#expand {
  margin-top: 0px;
  float: left;
}
.title {
  text-align: left;
  margin: 0px;
  padding: 0px;
  font-size: 20px;
  margin-bottom: 60px;
}
.outer {
  padding: 0px 100px;
  max-height: 60vh;
}
.btn-outline-primary {
  margin-top: 5%;
  -webkit-transition: opacity 0ms ease-in-out;
  -moz-transition: opacity 0ms ease-in-out;
  -o-transition: opacity 0ms ease-in-out;
  transition: opacity 0ms ease-in-out;
}
.btn-outline-primary.show {
  visibility: visible;
}
p.question {
  font-size: 33px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: 1px;
  text-align: left;
  height: 100px;
  margin-bottom: 20px;
}
div.explanation {
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: 1px;
  color: #ffffff;
  text-align: left;
  margin-bottom: 20px;
  min-height: 165px;
  max-height: 230px;
  overflow: hidden;
  overflow-y: scroll;
}
.card {
  width: 1180px;
  height: 340px;
  background-color: #3D3F47;
  border-radius: 30px;
}
#nextD {
  float: right;
  margin-bottom: 50px;
  margin-top: 19px;
}
#backD {
  float: left;
  margin-bottom: 50px;
  margin-top: 19px;
}
.container {
  max-width: 1180px;
  padding: 0px;
}
.container .item {
  padding: 10px 30px 0px 30px;
  text-align: left;
  -webkit-user-select: none;
  user-select: none;
  height: 340px;
}
/*# sourceMappingURL=question.component.css.map */
